import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetAPICommand, GetListAPICommand} from '@drl/core/core.module';
import {environment} from '@drl/env/environment';

export class GetLeadsDashboardCount<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(
      apiService,
      adapter,
      `${environment.patientApiUrl}/leads/dashboard-count`,
    );
  }
}
